import React from 'react'

const text = props => <div className='text'>
  <h2>Error</h2>
</div>

export default text